namespace app.autenticacao {
    "use strict";
    
    import IStateProvider = angular.ui.IStateProvider;
    import ITranslatePartialLoaderProvider = angular.translate.ITranslatePartialLoaderProvider;

    /** @ngInject **/
    function config($translatePartialLoaderProvider: ITranslatePartialLoaderProvider,
                    $stateProvider: IStateProvider) {
        $translatePartialLoaderProvider.addPart("app/main/autenticacao/nao-autenticado");

        $stateProvider
            .state("app.nao-autenticado", {
                abstract: true,
                views: {
                    "main@": {
                        templateUrl: "app/custom/layouts/content-only.html",
                        controller : MainController,
                        controllerAs: "vm"
                    },
                    "content@app.nao-autenticado": {
                        templateUrl: "app/main/autenticacao/nao-autenticado/nao-autenticado.html"
                    }
                }
            })
            .state("app.publico", {
                abstract: true,
                parent: "app.nao-autenticado",
                url: "/publico"           
            });
    }

    angular
        .module("app.nao-autenticado", ["app.autenticacao", "app.navigation"])
        .config(config);
}